import React, {useEffect} from 'react';
import {Box, Grid} from '@mui/material';
import AutoField, {ActionType} from '../AutoForm/AutoFieldNew';
import {camelCaseToCapitalisedString} from '../../utils/camelCaseToCapitalisedString';
import {useAutoForm} from '../AutoForm/useAutoForm';
import {UPDATES} from '../../shared/UPDATES';
import {Vulnerabilities} from '../../schema-types/Vulnerabilities';
import {
  AccountVulnerabilitiesFragment_primaryContact,
  AccountVulnerabilitiesFragment_secondaryContact,
} from '../../schema-types/AccountVulnerabilitiesFragment';
import {
  longTermVul,
  longTermVulTypes,
  shortTermVul,
  shortTermVulTypes,
} from '../../pages/PostcursorPage/vulnerabilities';

export const SimpleVulnerabilityFields: React.FC<{
  contact:
    | AccountVulnerabilitiesFragment_primaryContact
    | AccountVulnerabilitiesFragment_secondaryContact;
}> = ({contact}) => {
  const {setFieldValue} = useAutoForm<AccountVulnerabilitiesFragment_primaryContact>();
  useEffect(() => {
    const eventVulnerabilityTypes = [];
    const longTermVulnerabilityTypes = [];
    let isVulnerable = false;
    let isEventVulnerable = false;

    for (const keyUnprocessed of Object.keys(contact)) {
      const key = keyUnprocessed as keyof Vulnerabilities;
      if (key === '__typename') {
        // do nothing
      } else if (longTermVul.includes(key as longTermVulTypes) && contact[key] === true) {
        longTermVulnerabilityTypes.push(key);
        isVulnerable = true;
      } else if (
        shortTermVul.includes(key as shortTermVulTypes) &&
        contact[key] === true
      ) {
        eventVulnerabilityTypes.push(key);
        isEventVulnerable = true;
      }
    }

    setFieldValue(UPDATES._4300, 'isVulnerable', isVulnerable);
    setFieldValue(UPDATES._4301, 'isEventVulnerable', isEventVulnerable);
    setFieldValue(
      UPDATES._4302,
      'longTermVulnerabilityTypes',
      longTermVulnerabilityTypes
    );
    setFieldValue(UPDATES._4303, 'eventVulnerabilityTypes', eventVulnerabilityTypes);
  }, []);

  return (
    <>
      <Grid item xs={6} pl={2} pr={2}>
        <AutoField
          field={{
            id: 'isVulnerable',
            fullWidth: true,
            label: 'Long-term vulnerable',
            type: ActionType.checkboxToggle,
            readOnly: true,
          }}
        />
        <Box mt={2} />
        <AutoField
          field={{
            id: 'longTermVulnerabilityTypes' as any,
            type: ActionType.checkboxGroup,
            label: 'Long-term vulnerabilities',
            options: longTermVul.map((x) => ({
              value: x,
              label: camelCaseToCapitalisedString(x).replace('vulnerability', ''),
            })),
            // disabled: !longVuln.value || readOnly,
            horizontal: true,
            horizontalOptionWidthXs: 12,
            horizontalOptionWidthMd: 6,
            horizontalOptionWidthLg: 6,
            size: 'small',
            boldLabel: true,
            fullWidth: true,
            readOnly: true,
          }}
        />
      </Grid>
      <Box mt={4} />
      <Grid item xs={6} pl={2} pr={2}>
        <AutoField
          field={{
            id: 'isEventVulnerable',
            fullWidth: true,
            label: 'Circumstantially vulnerable',
            type: ActionType.checkboxToggle,
            readOnly: true,
          }}
        />
        <Box mt={2} />
        <AutoField
          field={{
            id: 'eventVulnerabilityTypes' as any,
            type: ActionType.checkboxGroup,
            label: 'Circumstantial vulnerabilities',
            boldLabel: true,
            fullWidth: true,
            // disabled: !eventVuln.value || readOnly,
            options: shortTermVul.map((x) => ({
              value: x,
              label: camelCaseToCapitalisedString(x).replace('vulnerability', ''),
            })),
            horizontal: true,
            horizontalOptionWidthXs: 12,
            horizontalOptionWidthMd: 6,
            horizontalOptionWidthLg: 6,
            size: 'small',
            readOnly: true,
          }}
        />
        <Box mt={2} />
        <AutoField
          field={{
            id: 'specialCareReasons',
            fullWidth: true,
            label: 'Recent circumstance changes',
            type: ActionType.text,
            multiline: true,
            // disabled: !eventVuln.value || readOnly,
            minRows: 4,
            initialValue: contact?.specialCareReasons || '',
            showCounter: true,
            charLimit: 255,
            readOnly: true,
          }}
        />
      </Grid>
    </>
  );
};
